import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../web/components-v2/Theme/theme';
import tysonBackgroundImage from '../assets/tyson-background.png';
import { brandPrimaryDark, titles, warningDark } from '../styles/colors';

export const styleSheet = StyleSheet.create({
	noCoffee: {
		background: warningDark,
		color: titles,
		padding: SPACE[20],
		position: 'absolute',
		top: 105,
		width: '100vw',
		zIndex: 1000,
	},
	subBar: {
		alignItems: 'center',
		background: brandPrimaryDark,
		display: 'flex',
		width: '100%',
	},
	statusBannerInGrid: {
		// The grid places this row, so the legacy viewport pinning is undone. Relative rather than static: Tyson Mode
		// and Start a Blitz are absolutely positioned from the banner's right edge, not past it over the user menu.
		position: 'relative',
		top: 'auto',
		left: 'auto',
		right: 'auto',
		flex: 1,
		// The row paints the bar so it runs on behind the user-menu signpost. The legacy hover darkening is dropped:
		// the banner itself isn't clickable, only the buttons inside it.
		background: 'transparent',
		':hover': {
			background: 'transparent',
		},
	},
	userMenuSignpost: {
		color: THEME.colors.primary.contrastText,
		marginRight: SPACE[16],
	},
	tysonBackground: {
		backgroundColor: `#22D363`,
		backgroundImage: `url("${tysonBackgroundImage}")`,
		backgroundPosition: 'center top',
		backgroundRepeat: 'repeat-x',
		backgroundSize: 'contain',
	},
});
